export default "__VITE_ASSET__CeSuyOp4__"